export default __webpack_public_path__ + "static/media/ncso.29c6fba9.png";